// extracted by mini-css-extract-plugin
module.exports = {"Keynote":"Keynote__10VTQ"};